<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.userInfo.user.roles[0].id == 1" :to="{path: '/home'}">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('orderManagement')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('orderInfo')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-form ref="form" :model="form" label-width="120px">
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="form.phone" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('mchOrderNo')" style="margin-left: 600px;margin-top: -60px;">
                            <el-input v-model="form.mchOrderNo" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('email')">
                            <el-input v-model="form.email" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('userName')" style="margin-left: 600px;margin-top: -60px;">
                            <el-input v-model="form.userName" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('cantidad')">
                            <el-input v-model="form.cantidad" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('days')" style="margin-left: 600px;margin-top: -60px;">
                            <el-input v-model="form.days" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('overdueDay')">
                            <el-input v-model="form.overdueDay" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('expireTime')" style="margin-left: 600px;margin-top: -60px;">
                            <el-input v-model="form.expireTime" style="width:400px;" :disabled="true" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('stats')">
                            <el-input v-model="form.stats" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('exclusiveLinks')" style="margin-left: 600px;margin-top: -60px;">
                            <el-input v-model="form.exclusiveLinks" style="width:400px;" :disabled="true"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="cont" style="margin-top: 15px;">
            <div class="listbox">
                <div class="listright" v-loading="loading1">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('phone')">
                                    <el-input v-model="searchform.blurry" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('phone')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('guanxi')">
                                    <el-select size="small" v-model="searchform.type" style="width:120px;" :placeholder="$t('qxzguanxi')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option label="Normal" :value="1"></el-option>
                                        <el-option label="Emergency" :value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" stripe border style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="name" :label="$t('name')"></el-table-column>
                        <el-table-column prop="concern" :label="$t('guanxi')"></el-table-column>
                        <el-table-column prop="type" :label="$t('jjlxr')"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <div class="cont" style="margin-top: 15px;">
            <div class="listbox">
                <div class="listright" v-loading="loading2">
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{addInfo}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list1" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="clientName" :label="$t('name')"></el-table-column>
                        <el-table-column prop="tel" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="callTime" :label="$t('telTime')">
                            <template slot-scope="scope">
                                {{scope.row.callTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="concern" :label="$t('guanxi')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.concern==1" type="info">Padre/Madre</el-tag>
                                <el-tag v-if="scope.row.concern==2" type="info">Hermano(a)</el-tag>
                                <el-tag v-if="scope.row.concern==3" type="info">Amigo(a)</el-tag>
                                <el-tag v-if="scope.row.concern==4" type="info">Hijo(a)</el-tag>
                                <el-tag v-if="scope.row.concern==5" type="info">Abuelo(a)</el-tag>
                                <el-tag v-if="scope.row.concern==6" type="info">Tío(a)</el-tag>
                                <el-tag v-if="scope.row.concern==7" type="info">Primo(a)</el-tag>
                                <el-tag v-if="scope.row.concern==8" type="info">Sobrino(a)</el-tag>
                                <el-tag v-if="scope.row.concern==9" type="info">Otro</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="acceptorTime" :label="$t('rlTime')"></el-table-column>
                        <el-table-column prop="className" :label="$t('fl')"></el-table-column>
                        <el-table-column prop="userName" :label="$t('yg')"></el-table-column>
                        <el-table-column prop="remark" :label="$t('beizhu')"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                            @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1?$t('addInfo'):$t('editInfo')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" class="addCss">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="120px">
                    <el-form-item :label="$t('name')">
                        <el-input v-model="form.clientName" style="width: 300px;"/>
                    </el-form-item>
                    <el-form-item :label="$t('phone')">
                        <el-input v-model="form.tel" />
                    </el-form-item>
                    <el-form-item :label="$t('guanxi')">
                        <el-select size="small" v-model="form.concern" style="width:340px;" :placeholder="$t('qxzguanxi')"  >
                            <el-option label="Padre/Madre" :value="1"></el-option>
                            <el-option label="Hermano(a)" :value='2'></el-option>
                            <el-option label="Amigo(a)" :value="3"></el-option>
                            <el-option label="Hijo(a)" :value="4"></el-option>
                            <el-option label="Abuelo(a)" :value="5"></el-option>
                            <el-option label="Tío(a)" :value="6"></el-option>
                            <el-option label="Primo(a)" :value="7"></el-option>
                            <el-option label="Sobrino(a)" :value="8"></el-option>
                            <el-option label="Otro" :value="Otro"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('rlTime')">
                        <el-col :span="11">
                            <el-date-picker type="date" :placeholder="$t('xzTime')" v-model="form.acceptorTime" style="width: 150%;">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item :label="$t('fl')">
                        <el-select size="small" v-model="form.classId" filterable :placeholder="$t('qxzflmc')"  style="width:300px;">
                            <el-option :label="$t('qxzflmc')" :value="null"></el-option>
                            <el-option
                            v-for="item in classlist"
                            :key="item.id"
                            :label="item.classifyName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('beizhu')">
                        <el-input type="textarea" v-model="form.remark" />
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    export default {
        data(){
            return{
                loading : false,
                loading1 : false,
                loading2 : false,
                isloaded : false,
                form:{
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null
                },
                searchform: {},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                total1: 1,
                pageNo1: 1,
                pageSize1: 10,
                list: [],
                classlist: [],
                showadd: false,
                list1: []
            }
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            const name = this.user.user.username

            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            const timeArr = UTCTime - 6 * 60 * 60 * 1000;
            const timeStr = this.formatTime(timeArr)
            this.addWatermark(`${name} ${timeStr}`)
        },
        created(){
            this.userInfo=JSON.parse(localStorage.getItem("userinfo"))
            this.form.orderId= this.$route.query.orderId
            this.form.userId= this.$route.query.userId
            this.getDetail()
            this.getContcatList()
            this.getList1()
            this.getclass()
        },
        methods:{
            addWatermark(text) {
                const canvas = document.createElement('canvas')
                canvas.width = 300
                canvas.height = 200
                const ctx = canvas.getContext('2d')
                ctx.rotate(-20 * Math.PI / 180)
                ctx.font = '16px Arial'
                ctx.fillStyle = 'rgba(0,0,0,0.08)'
                ctx.fillText(text, 20, 100)
                const base64 = canvas.toDataURL()
                const div = document.createElement('div')
                div.style.position = 'fixed'
                div.style.top = '0'
                div.style.left = '0'
                div.style.width = '100%'
                div.style.height = '100%'
                div.style.pointerEvents = 'none'
                div.style.backgroundImage = `url(${base64})`
                div.style.zIndex = '9999'
                document.body.appendChild(div)
            },
            formatTime(timestamp) {
                const d = new Date(timestamp)
                const pad = (n) => n.toString().padStart(2, '0')

                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            },
            getDetail(){
                this.isloaded=true
                _api.get(apiurl.orderDetail,{
                    orderId:this.form.orderId
                }).then(res=>{
                    this.form.phone=res.data.phone
                    this.form.mchOrderNo=res.data.mchOrderNo
                    this.form.email=res.data.email
                    this.form.userName=res.data.userName
                    this.form.cantidad=res.data.cantidad
                    this.form.days=res.data.days
                    this.form.overdueDay=res.data.overdueDay
                    this.form.expireTime=res.data.expireTime
                    this.form.createTime=res.data.createTime
                    this.form.exclusiveLinks=res.data.exclusiveLinks
                    this.form.stats=res.data.stats
                    this.loading = false
                })
            },
            getContcatList(){
                this.loading1 = true
                _api.get(apiurl.userContact, {
                    page: this.pageNo,
                    size: this.pageSize,
                    userId: this.form.userId,
                    type: this.searchform.type,
                    blurry: this.searchform.blurry
                }).then(res => {
                    this.loading1 = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            getclass() {
                _api.get(apiurl.classifyAll, {
                }).then(res => {
                    this.classlist = res.data
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getContcatList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getContcatList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getContcatList()
            },
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    clientName: null,
                    tel: null,
                    callTime: null,
                    concern: null,
                    acceptorTime: null,
                    className: null,
                    remark: null,
                    userName: null,
                    orderId: this.$route.query.orderId
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.clientName = row.clientName
                this.form.tel = row.tel
                this.form.callTime = row.callTime
                this.form.concern = row.concern
                this.form.acceptorTime = row.acceptorTime
                this.form.className = row.className
                this.form.remark = row.remark
                this.form.userName = row.userName
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList1()
            },
            deleteproduct(row) {
                _api.delete(apiurl.callInfo, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.getList1()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.callInfo, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.getList1()
                        this.showadd = false
                        this.form = {
                            id: null,
                            clientName: null,
                            tel: null,
                            callTime: null,
                            concern: null,
                            acceptorTime: null,
                            className: null,
                            remark: null,
                            userName: null,
                            orderId: this.$route.query.orderId
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.callInfo, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.getList1()
                        this.showadd = false
                        this.form = {
                            id: null,
                            clientName: null,
                            tel: null,
                            callTime: null,
                            concern: null,
                            acceptorTime: null,
                            className: null,
                            remark: null,
                            userName: null,
                            orderId: this.$route.query.orderId
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList1() {
                this.loading2 = true
                _api.get(apiurl.callInfo, {
                    page: this.pageNo1,
                    size: this.pageSize1,
                    orderId:this.$route.query.orderId
                }).then(res => {
                    this.loading2 = false
                    this.list1 = res.data.list
                    this.total1 = res.data.total
                })
            },
            handchange1(data) { //分页Size变化
                this.pageSize1 = data
                this.pageNo1 = 1
                this.getList1()
            },
            currentchange1(data) { //当前页变化
                this.pageNo1 = data
                this.getList1()
            },
        }
    }
</script>
<style scoped>
    .formbox{ padding:15px 0; margin-top: 10px;}
    .searchright{padding-bottom: 10px;}
    .addCss{width: 500px;}
</style>